import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { Company } from 'types';
import { CompanyCard } from 'views/companies/CompaniesListPage/components';
import { COMPANY_LIST_TEXT } from './constants';

interface CompanyGridProps {
  companies: Company[];
}

export const CompanyGrid = memo<CompanyGridProps>(({ companies }) => {
  const renderCompanyCard = (company: any) => {
    if (company.referrerCount === 0) {
      return null;
    }
    return <CompanyCard key={company.id ?? company.company} company={company} />;
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1280px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        columnGap: '16px',
        rowGap: '32px',
      }}
      role="grid"
      aria-label="Company listings"
    >
      {companies?.map(renderCompanyCard)}
      
      {companies.length === 0 && (
        <Typography 
          color="text.secondary"
          role="status"
          aria-live="polite"
        >
          {COMPANY_LIST_TEXT.NO_COMPANIES_MESSAGE}
        </Typography>
      )}
    </Box>
  );
});

CompanyGrid.displayName = 'CompanyGrid';
